@let label = labelSg();
@let selectedRange = listStore.selectedRangeSg();
<div class="atn-ds-input-field">
  @if (label) {
    <span class="atn-ds-input-field__label"> {{ label }} </span>
  }

  <div>
    <!-- 
  We must always keep <atn-ds-date-range-input> in the DOM because Angular
  Material's date picker expects the input to be present for internal handling.

  For multi-range support, we display a custom-styled input
  (<atn-ds-multiple-date-range-input>) in place of the base input, which is
  visually hidden.
-->
    <atn-ds-date-range-input
      style="visibility: hidden; display: block; height: 0"
      [rangePicker]="overlay.picker"
      [value]="selectedRange"
    />

    <atn-ds-date-multi-range-input
      (click)="openDateRangePickerHandler(overlay.picker)"
    />
  </div>
</div>

<atn-ds-date-range-overlay
  #overlay
  (apply)="applyChangesHandler()"
  (cancel)="discardChangesHandler()"
/>
